"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_if_1 = require("react-if");
const react_2 = require("@osmosys/react");
const index_1 = require("./NavRight/index");
const OsmosysLoadingIndicator_1 = require("./OsmosysLoadingIndicator");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const hooks_1 = require("../../../hooks");
const OsmosysAppVersionText_1 = require("./OsmosysAppVersionText");
const react_use_1 = require("react-use");
const OsmosysNetworkConnectionToast_1 = require("./OsmosysNetworkConnectionToast");
exports.AppNav = () => {
    const { online } = react_use_1.useNetwork();
    const { location } = use_react_router_1.default();
    const appDataContext = hooks_1.useOsmosysContext();
    const { currentUser, appSettings, appHasLoaded } = appDataContext;
    let showBreadcrumbs = true;
    if (!currentUser) {
        showBreadcrumbs = false;
    }
    else {
        if (!currentUser.workspaceMemberships ||
            currentUser.workspaceMemberships.length === 0) {
            showBreadcrumbs = false;
        }
    }
    const loggedIn = !!currentUser;
    const showFullLogoBool = react_1.useMemo(() => {
        return (!loggedIn ||
            location.pathname.startsWith('/invite') ||
            [
                '',
                '/',
                '/login',
                '/signup',
                '/forgot-password',
                '/reset-password',
            ].includes(location.pathname));
    }, [location.pathname, loggedIn]);
    const isHome = (pathname) => pathname === '/' || pathname === '';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(OsmosysNetworkConnectionToast_1.OsmosysNetworkConnectionToast, { online: online }),
        react_1.default.createElement(OsmosysLoadingIndicator_1.OsmosysLoadingIndicator, { online: online }),
        react_1.default.createElement(react_2.OsmosysDiv, { osysName: "AppNav" },
            react_1.default.createElement(react_2.OsmosysAppNav, { isHome: isHome(location.pathname), showFullLogo: showFullLogoBool, logoLabel: react_1.default.createElement(OsmosysAppVersionText_1.OsmosysAppVersionText, { version: appSettings ? appSettings.version : `${process.env.GIT_SHA}` }), breadcrumbs: react_1.default.createElement(react_if_1.When, { condition: appHasLoaded }, !isHome(location.pathname) && showBreadcrumbs && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_2.OsmosysAppNav.Item, { to: "/", tooltip: "Home" },
                        react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "home", iconStyle: "solid" })),
                    react_1.default.createElement(react_2.OsmosysAppNav.Breadcrumb, { basePath: "/emails", pathname: location.pathname, resourceLabel: "Emails" }),
                    react_1.default.createElement(react_2.OsmosysAppNav.Breadcrumb, { basePath: "/ads", pathname: location.pathname, resourceLabel: "Ads" }),
                    react_1.default.createElement(react_2.OsmosysAppNav.Breadcrumb, { basePath: "/templates", pathname: location.pathname, resourceLabel: "Templates" }),
                    react_1.default.createElement(react_2.OsmosysAppNav.Breadcrumb, { basePath: "/integrations", pathname: location.pathname, resourceLabel: "Integrations" }),
                    react_1.default.createElement(react_2.OsmosysAppNav.Breadcrumb, { basePath: "/workflows", pathname: location.pathname, resourceLabel: "Workflows" }),
                    react_1.default.createElement(react_2.OsmosysAppNav.Breadcrumb, { basePath: "/admin/users", pathname: location.pathname, resourceLabel: "Users", isAdminOnly: true }),
                    react_1.default.createElement(react_2.OsmosysAppNav.Breadcrumb, { basePath: "/admin/workspaces", pathname: location.pathname, resourceLabel: "Workspaces", isAdminOnly: true })))) },
                react_1.default.createElement(index_1.NavRight, null)))));
};
//# sourceMappingURL=index.js.map